import { actionTypes } from '../../types';

// Action request
export const getAllAgencyUser = (payload, callback) => ({
    type: actionTypes.GET_ALL_AGENCY_USER_REQUEST,
    payload,
    callback
});

// Action success
export const getAllAgencyUserSuccess = (payload) => ({
    type: actionTypes.GET_ALL_AGENCY_USER_SUCCESS,
    payload,
});

// Action failure
export const getAllAgencyUserFailure = (payload) => ({
    type: actionTypes.GET_ALL_AGENCY_USER_FAILURE,
    payload,
});

// Action reset status
export const getAllAgencyUserReset = () => ({
    type: actionTypes.GET_ALL_AGENCY_USER_RESET,
});

// Action reset all reducer
export const getAllAgencyUserResetAll = () => ({
    type: actionTypes.GET_ALL_AGENCY_USER_RESET_ALL,
});
